<template>
    <div>
        <h3>Basic technical requirements</h3>
        <p>These requirements are the same for all backend stacks</p>
        <ul>
            <li>Version your code using <a href="https://github.com/" target="_blank">git</a></li>
            <li>Have a <i>local development</i> server</li>
            <li>Have <i>unit tests</i></li>
            <li>Be <i>fault-tolerant</i> <span class="comment">/* expect things to fail */</span></li>
            <li>Implement all endpoints of the API as specified by the <router-link to="/api">API specs</router-link>.</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'BackendTechReq'
}
</script>